import React from 'react';
import {showSnackbarNotification} from '@esgi/ui-kit/snackbar';
import {FormControl} from '@esgi/ui-kit/form';
import {Buttons} from '@esgi/ui-kit/button';
import {join} from '@esgi/ui-kit/utils';
import {OnHoverTooltip} from '@esgi/ui-kit/tooltip';
import {ModalWindow} from '@esgi/deprecated/knockout';
import {StateStandardsLibrary} from 'shared/modules/state-standards-library';
import {userStorage} from '@esgi/core/authentication';
import {ClearIcon} from '../../../../../../common/rubric-edit-form/icons';
import RubricService from '../../../../../../common/rubric-service';
import {Field} from '../type';

import styles from '../confirm.module.less';

class State {
	stateStandardName = '';
}

interface Props {
	rubricService: RubricService;
	contentAreaControl: FormControl<Field>;
}

export default class StateStandardField extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		const state = new State();
		state.stateStandardName = props.rubricService.testInfo$.value.stateStandard;
		this.state = state;
	}

	public render() {
		return <div className={join(styles.inlineField, styles.stateStandardField)}>
			<div className={styles.label}>State Standard:</div>
			<div className={styles.element}>
				<Buttons.Link className={styles.stateStandardButton}
				                  onClick={() => this.openStateStandard()}>
										<span>
											{this.state.stateStandardName || 'State Standard'}
										</span>
				</Buttons.Link>
				{this.state.stateStandardName && <OnHoverTooltip message='Clear'>
					<div className={styles.clearStateStandard}>
						<ClearIcon
							onClick={() => this.setState({stateStandardName: ''}, () => this.props.rubricService.updateTestInfo({stateStandardID: 0}))}/>
					</div>
				</OnHoverTooltip>}
			</div>
		</div>;
	}

	private openStateStandard(): void {
		const currentUser = userStorage.get();

		const stateStandardsLibrary = new StateStandardsLibrary(
			{
				selectedContentAreaId: this.props.contentAreaControl.value[0]?.id,
				stateId: currentUser.stateID,
			},
		);

		let modal = new ModalWindow(stateStandardsLibrary,
			{
				allowClose: true,
				showHeader: true,
				showFooter: true,
				className: 'state-standard-modal',
				title: 'State Standards Library',
				buttons: [
					{
						title: 'Add',
						className: 'btn btn-primary btn-sm',
						submit: true,
						align: 'right',
						onClick: stateStandardsLibrary.view.okClicked,
						closeModal: false,

					},
					{
						title: 'Close',
						className: 'btn btn-sm ',
						submit: true,
						align: 'right',
						icon: 'fa fa-times',
						closeModal: true,
						cancel: true,
					},
				],
			});

		stateStandardsLibrary.events.onUpdate((event, changes) => {
			showSnackbarNotification(`State Standard has been added`);
			this.props.rubricService.updateTestInfo({
				stateStandard: changes.stateStandard,
				stateStandardID: changes.stateStandardId,
			});
			this.setState({stateStandardName: changes.stateStandard});
		});

		stateStandardsLibrary.events.onClosed(() => {
			modal.close();
		});

		modal.load();
	}
}
